// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  t363 (21-oct-2026) · CADA PANTALLA EN SU TROZO, Y SE DESCARGA CUANDO SE ABRE
// ══════════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  EL FALLO, MEDIDO. App.jsx importa sus ~150 pantallas de golpe (`import Pacientes from './pages/Pacientes'`…), así que el
//  JS con el que arranca la aplicación (assets/index-*.js) las llevaba TODAS: 12,1 MB (3 MB comprimido), también la
//  contabilidad, el control horario, el portal del paciente o todo Superadmin para quien entra a la agenda. Y como cada subida
//  cambia el nombre de ese fichero, cada persona lo volvía a bajar ENTERO después de cada despliegue.
//
//  LO QUE HACE. El plugin de frontend/paginasPorTrozos.js (solo al construir, `vite build`) cambia cada una de esas líneas por
//  `const Pacientes = paginaPorTrozos(() => import('./pages/Pacientes'))`, y esto devuelve un componente que se pinta igual
//  que la pantalla: la primera vez que se abre baja su trozo (assets/Pacientes-*.js) y, mientras llega, enseña «Cargando…» EN
//  SU SITIO (el menú y la barra de arriba siguen). Los trozos que no cambian en una subida conservan su nombre, así que el
//  navegador no los vuelve a bajar.
//  El fuente de App.jsx no cambia: las guardias que lo leen siguen viendo sus `import`, y en las pruebas las pantallas se
//  cargan como siempre.
//
//  SI EL TROZO NO LLEGA (una subida nueva mientras la pestaña estaba abierta): lo mismo que con cualquier otro trozo, el
//  recuadro «Hay una versión nueva de la aplicación» y la recarga sola (components/ErrorBoundary · esFalloDeCarga).
import { lazy, Suspense, useEffect, useState } from 'react'
import { t as i18nT } from './i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

// «Cargando…» solo si tarda: un trozo que ya está en la caché del navegador llega en milisegundos y no se ve parpadear nada.
export function CargandoPagina() {
  const [ver, setVer] = useState(false)
  useEffect(() => {
    const t = setTimeout(() => setVer(true), 250)
    return () => clearTimeout(t)
  }, [])
  if (!ver) return null
  return (
    <div role="status" aria-busy="true" data-cargando-pagina=""
      style={{ padding: '24px 16px', color: 'var(--text-secondary, #64748b)', fontSize: 14 }}>
      {i18nT('utils.paginaPorTrozos.cargando', 'Cargando…')}
    </div>
  )
}

export default function paginaPorTrozos(cargar, nombre = '') {
  const Perezosa = lazy(cargar)
  function Pagina(props) {
    return (
      <Suspense fallback={<CargandoPagina />}>
        <Perezosa {...props} />
      </Suspense>
    )
  }
  Pagina.displayName = 'PaginaPorTrozos(' + (nombre || 'pantalla') + ')'
  return Pagina
}
